module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"specialCategory":"Mark if a dish is special","specialFrameCategory":"Add special frame to a dish","visibleCategory":"Mark product as visible"},"es":{"specialCategory":"Marcar si un plato es especial","specialFrameCategory":"Añadir marco especial a un plato","visibleCategory":"Marcar producto como visible"}}')
  delete Component.options._Ctor
}
